window.Theme = window.Theme || {};
Theme.Product = (() => {
  // let productSlider, productThumbSlider; // already declared globally in theme-scripts.liquid
  let currentVideo = null;

  const getMousePos = (e) => {
    var pos = e.currentTarget.getBoundingClientRect();
    return {
      x: e.clientX - pos.left,
      y: e.clientY - pos.top,
    };
  };

  function pauseMedia(container) {
    container.querySelectorAll('.yv-youtube-video').forEach(video =>
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    );
    container.querySelectorAll('.yv-vimeo-video').forEach(video =>
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    );
    container.querySelectorAll('video').forEach(video => video.pause());
  }

  function initProductSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        productSlider?.destroy();
      }
    }

    if (sliderMain.hasAttribute('data-mobile-only')) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute('data-desktop-only')) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          setTimeout(() => productSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productSlider = new Flickity(sliderMain, options);
        setTimeout(() => productSlider.resize(), 300);
      }
    }

    if (productSlider) {
      productSlider.on('change', function () {
        pauseMedia(productSlider.element);
      });
    }
  }

  function initProductThumbSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-thumb-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-thumb-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider?.destroy();
      }
    }

    if (sliderMain.hasAttribute('data-mobile-only')) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute('data-desktop-only')) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider = new Flickity(sliderMain, options);
        setTimeout(() => productThumbSlider.resize(), 300);
      }
    }

    if (productThumbSlider) {
      productThumbSlider.on('change', function () {
        pauseMedia(productThumbSlider.element);
      });
    }
  }

  function findVisibleItems() {
    let mainSliderParent = document.getElementById('yv-product-gallery-slider');
    if (mainSliderParent) {
      let elements = mainSliderParent.getElementsByClassName('gallery-main-item');
      let thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');

      window.addEventListener('scroll', () => {
        Array.from(elements).forEach(item => {
          if (isOnScreen(item)) {
            let relatedThumb = mainSliderParent.querySelector('.gallery-thumbs-item[data-image="' + item.id + '"]');
            if (relatedThumb) {
              Array.from(thumbs).forEach(thumb => thumb.classList.remove('active'));
              relatedThumb.classList.add('active');
            }
          }
        });
      });
    }

    let mainTabsContent = document.getElementById('yvProductFeatureListwrapper');
    if (mainTabsContent) {
      let contentTabs = document.getElementsByClassName('yv-product-feature');
      window.addEventListener('scroll', function () {
        Array.from(contentTabs).forEach(function (item) {
          if (isOnScreen(item)) {
            let headTabs = document.getElementsByClassName('feature-link');
            Array.from(headTabs).forEach(function (head) {
              head.parentNode.classList.remove('active');
            });
            var relatedHead = document.querySelector('.feature-link[href="#' + item.id + '"]');
            if (relatedHead) {
              relatedHead.parentNode.classList.add('active');
            }
          }
        });
      });
    }
  }

  function sizeChart() {
    let sizeChartInit = document.querySelectorAll('.sizeChart-label');
    let sizeChartModel = document.getElementById('sizeChartModel');
    if (sizeChartInit && sizeChartModel) {
      let sizeChartClose = sizeChartModel.querySelector('#sizeChartClose');
      sizeChartInit.forEach(label => {
        label.addEventListener('click', e => {
          e.preventDefault();
          document.body.classList.add('sizeChartOpen');
          sizeChartClose.focus();
        });
      });
      sizeChartClose.addEventListener('click', () => {
        document.body.classList.remove('sizeChartOpen');
      });
    }
  }

  function initStickyAddToCart() {
    let mainProductForm = document.querySelector('.main-product-form');
    let stickyBar = document.getElementById('yvProductStickyBar');

    if (mainProductForm && stickyBar) {
      window.addEventListener('scroll', () => {
        if (isOnScreen(mainProductForm, true) || window.scrollY < mainProductForm.offsetTop) {
          stickyBar.classList.remove('show');
        } else {
          stickyBar.classList.add('show');
        }
      });
    }
  }

  function getSelectedVariantId(productInfo) {
    if (!productInfo) return null;

    const variantInput =
      productInfo.querySelector('input[name="id"]') ||
      document.querySelector('input[name="id"]');

    if (!variantInput || !variantInput.value) return null;
    return String(variantInput.value);
  }

  function getProductJson(productInfo) {
    if (!productInfo) return null;

    const possibleJsonEls = [
      productInfo.querySelector('[data-product-json]'),
      productInfo.querySelector('script[type="application/json"][data-product-json]'),
      productInfo.querySelector('script[type="application/json"]'),
      document.querySelector('[data-product-json]'),
      document.querySelector('script[type="application/json"][data-product-json]')
    ].filter(Boolean);

    for (const el of possibleJsonEls) {
      try {
        const parsed = JSON.parse(el.textContent);
        if (parsed && (parsed.variants || Array.isArray(parsed))) {
          return parsed;
        }
      } catch (e) {
        // ignore invalid JSON blocks
      }
    }

    return null;
  }

  function getSelectedVariant(productInfo) {
    const selectedVariantId = getSelectedVariantId(productInfo);
    if (!selectedVariantId) return null;

    const productJson = getProductJson(productInfo);
    if (!productJson) return null;

    const variants = Array.isArray(productJson) ? productJson : productJson.variants;
    if (!variants || !variants.length) return null;

    return variants.find(variant => String(variant.id) === selectedVariantId) || null;
  }

  function getSlideElementByMediaId(mainSliderEl, mediaId) {
    if (!mainSliderEl || !mediaId) return null;

    return (
      mainSliderEl.querySelector(`[data-media-id="${mediaId}"]`) ||
      mainSliderEl.querySelector(`#ProductMedia-${mediaId}`) ||
      mainSliderEl.querySelector(`#featured-media-${mediaId}`) ||
      mainSliderEl.querySelector(`[id="ProductMedia-${mediaId}"]`) ||
      mainSliderEl.querySelector(`[id="featured-media-${mediaId}"]`)
    );
  }

  function getThumbElementByMediaId(thumbSliderEl, mediaId) {
    if (!thumbSliderEl || !mediaId) return null;

    return (
      thumbSliderEl.querySelector(`[data-media-id="${mediaId}"]`) ||
      thumbSliderEl.querySelector(`[data-image="ProductMedia-${mediaId}"]`) ||
      thumbSliderEl.querySelector(`[data-image="featured-media-${mediaId}"]`) ||
      thumbSliderEl.querySelector(`[href="#ProductMedia-${mediaId}"]`) ||
      thumbSliderEl.querySelector(`[href="#featured-media-${mediaId}"]`)
    );
  }

  function syncVariantMedia(section = document) {
    const productInfo =
      section.querySelector('product-info') ||
      document.querySelector('product-info');

    if (!productInfo) return;

    const selectedVariant = getSelectedVariant(productInfo);
    if (!selectedVariant || !selectedVariant.featured_media) return;

    const mediaId = String(selectedVariant.featured_media.id);

    const mainSliderEl =
      section.querySelector('[data-flickity-product-slider]') ||
      document.querySelector('[data-flickity-product-slider]');

    const thumbSliderEl =
      section.querySelector('[data-flickity-product-thumb-slider]') ||
      document.querySelector('[data-flickity-product-thumb-slider]');

    const targetMediaEl = getSlideElementByMediaId(mainSliderEl, mediaId);
    const targetThumbEl = getThumbElementByMediaId(thumbSliderEl, mediaId);

    if (mainSliderEl && targetMediaEl && productSlider) {
      const slideCell = targetMediaEl.closest('.carousel-cell') || targetMediaEl;
      const slides = Array.from(mainSliderEl.children);
      const targetIndex = slides.indexOf(slideCell);

      if (targetIndex >= 0) {
        productSlider.select(targetIndex);
      }
    }

    if (thumbSliderEl) {
      thumbSliderEl.querySelectorAll('.gallery-thumbs-item').forEach(item => {
        item.classList.remove('active');
      });

      if (targetThumbEl) {
        targetThumbEl.classList.add('active');

        if (productThumbSlider) {
          const thumbCell = targetThumbEl.closest('.carousel-cell') || targetThumbEl;
          const thumbs = Array.from(thumbSliderEl.children);
          const thumbIndex = thumbs.indexOf(thumbCell);

          if (thumbIndex >= 0) {
            productThumbSlider.select(thumbIndex);
          }
        }
      }
    }

    if (!productSlider && targetMediaEl) {
      targetMediaEl.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }

  function bindVariantMediaSync(section = document) {
    const scope = section instanceof Element || section instanceof Document ? section : document;

    scope.querySelectorAll('.productOption, input[name="id"]').forEach((el) => {
      if (el.dataset.variantMediaBound === 'true') return;

      const syncHandler = () => {
        setTimeout(() => syncVariantMedia(scope), 120);
      };

      el.addEventListener('change', syncHandler);
      el.addEventListener('click', syncHandler);
      el.dataset.variantMediaBound = 'true';
    });

    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!target) return;

      if (target.matches('.productOption, input[name="id"]')) {
        setTimeout(() => syncVariantMedia(document), 120);
      }
    });
  }

  function onReadyEvent() {
    setTimeout(function () {
      var thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
      var lastKnownY = window.scrollY;
      var currentTop = 0;
      if (thumbnails) {
        var initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top);
        window.addEventListener('scroll', function () {
          var bounds = thumbnails.getBoundingClientRect(),
            maxTop = bounds.top + window.scrollY - thumbnails.offsetTop + initialTopOffset,
            minTop = thumbnails.clientHeight - window.innerHeight;
          if (window.scrollY < lastKnownY) {
            currentTop -= window.scrollY - lastKnownY;
          } else {
            currentTop += lastKnownY - window.scrollY;
          }
          currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset);
          lastKnownY = window.scrollY;
          thumbnails.style.top = ''.concat(currentTop, 'px');
        });
      }
    }, 1000);

    jQuery('body').on('click', '.pdp-view-close', function (e) {
      e.preventDefault();
      jQuery('#yvProductStickyBar').remove();
    });

    jQuery('body').on('click', '.feature-link', function (e) {
      e.preventDefault();
      let destination = jQuery(this).attr('href');
      let top = jQuery('.shopify-section-main-header').height() + 90;
      if (jQuery(destination).length > 0) {
        jQuery('html,body').animate({ scrollTop: (jQuery(destination).offset().top) - top });
      }
    });

    jQuery('body').on('change', '.sticky-bar-product-options', function () {
      let _section = jQuery(this).closest('.shopify-section');
      let option = jQuery(this).attr('data-name');
      let value = jQuery(this).val();
      let mainOption = _section.find('.productOption[name="' + option + '"]');
      if (mainOption.is(':radio')) {
        _section.find('.productOption[name="' + option + '"][value="' + CSS.escape(value) + '"]').attr('checked', true).trigger('click');
      } else {
        mainOption.val(value);
        let sectionId = document.querySelector('#' + _section.attr('id'));
        if (sectionId) {
          let optionSelector = document.querySelector('.productOption[name="' + option + '"]');
          if (optionSelector) {
            optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      setTimeout(() => syncVariantMedia(document), 120);
    });

    if (typeof fancySelector !== 'undefined') {
      Fancybox.bind(fancySelector, {
        touch: false,
        thumbs: {
          autoStart: true
        },
        on: {
          load: () => pauseMedia(document),
          done: () => pauseMedia(document)
        },
        Toolbar: {
          display: ['close']
        }
      });
    }
  }

  function productZoomInit() {
    $('.yv-product-zoom').mouseenter(function () {
      $('.yv-product-zoom').removeClass('show');
      if ($(window).width() > 1021) {
        $(this).addClass('show');
      }
    });

    $('.yv-product-zoom').mousemove(function (e) {
      if ($(window).width() > 1021) {
        let t = getMousePos(e);
        const cursor = this.querySelector('.gallery-cursor');
        if (cursor) {
          cursor.style.translate = `${t.x}px ${t.y}px`;
        }
      }
    });

    $('.yv-product-zoom').mouseleave(function () {
      $('.yv-product-zoom').removeClass('show');
    });
  }

  function load3DModel() {
    if (!window.Shopify) return;

    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: () => {
          if (!window.ShopifyXR || typeof window.ShopifyXR.addModels !== 'function') {
            document.addEventListener('shopify_xr_initialized', () => {
              load3DModel();
            });
            return;
          }

          document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
            window.ShopifyXR.addModels(JSON.parse(model.textContent));
          });
          window.ShopifyXR.setupXRElements();
        }
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: () => {
          document.querySelectorAll('.yv-product-model-item').forEach((model) => {
            let model3D = model.querySelector('model-viewer');
            model.modelViewerUI = new Shopify.ModelViewerUI(model3D);

            model3D.addEventListener('shopify_model_viewer_ui_toggle_play', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.remove('hidden'));
              if (productSlider) {
                productSlider.options.draggable = false;
                productSlider.updateDraggable();
              }
            });

            model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.add('hidden'));
              if (productSlider) {
                productSlider.options.draggable = true;
                productSlider.updateDraggable();
              }
            });

            model.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', () => model.modelViewerUI.pause());
            });
          });
        }
      }
    ]);
  }

  function onLoad(section = document) {
    initProductSlider(section);
    initProductThumbSlider(section);

    if (typeof findVisibleItems === 'function') {
      findVisibleItems();
    }

    productZoomInit();
    sizeChart();
    initStickyAddToCart();
    load3DModel();
    onReadyEvent();
    bindVariantMediaSync(section);

    setTimeout(() => syncVariantMedia(section), 200);
  }

  $(document).ready(function () {
    onLoad(document);
    onReadyEvent();

    function playVideo() {
      currentVideo = $('[data-reel-content] video')[0];
      if (currentVideo) {
        currentVideo.load();
        currentVideo.play();
      }
    }

    function pauseVideo() {
      if (currentVideo) {
        currentVideo.pause();
      }
    }

    setTimeout(() => syncVariantMedia(document), 300);
  });

  return {
    initProductSlider,
    initProductThumbSlider,
    syncVariantMedia,
    bindVariantMediaSync
  };
})();

if (document.querySelector('[data-flickity-product-slider]')) {
  window.addEventListener('resize', function () {
    Theme.Product.initProductSlider();
    Theme.Product.initProductThumbSlider();
    if (typeof findVisibleItems === 'function') {
      findVisibleItems();
    }
    if (Theme.Product.syncVariantMedia) {
      setTimeout(() => Theme.Product.syncVariantMedia(document), 150);
    }
  });
}